// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"f7f83ace","176":"0f018544","409":"1962d50d","432":"9ba65bec","831":"21d137cd"}[chunkId] + ".chunk.js";
};